module.exports = {
      id: "women-home-usage",
      viewBox: "0 0 64.575 75.722",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#women-home",
      toString: function () {
        return this.url;
      }
    }